import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-bg"></div>
      <div className="hero-content">
        <h1>Región Costalegre</h1>
        <p>Ordenamiento territorial y desarrollo sustentable</p>
        <div className="hero-buttons">
          <a href="#about" className="btn">Conoce más</a>
          <a href="#downloads" className="btn btn-outline">Descargas</a>
        </div>
      </div>
      <a href="#about" className="scroll-down">
        <i className="fas fa-chevron-down"></i>
      </a>
    </section>
  );
};

export default Hero;